import api from './api';
import types from './mutation-types';

export default {
	getCommCodes_({ commit, state }, { key, codeType }) {
		state.searchParams.codeType = codeType;
		return api
			.getCommCodes(state.searchParams)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: key,
						value: data !== null && data !== undefined ? data.body : null
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}
				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	setSearchPartPopParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PART_POP_PARAMS, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	setState_({ commit }, { key, value }) {
		//초기화
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	getCarSalesList_({ commit, state }) {
		const { searchParams } = state;
		return api
			.getSaleList({ searchParams })
			.then(data => {
				if (data.header.code === 0) {
					//console.log('조회된 값은:', data.body);

					//그리드 조회 상태업데이트
					commit(types.DEFAULT_ASSIGN, {
						key: 'grdSalesList',
						value: data !== null && data !== undefined ? data.body.resultList : null
					});

					// 바스택 조회 상태업데이트
					commit(types.DEFAULT_ASSIGN, {
						key: 'graphBarStackChartInfo',
						value: data !== null && data !== undefined ? data.body.graphBarStackChartInfo : null
					});

					// 파이 그래프 조회 상태업데이트
					commit(types.DEFAULT_ASSIGN, {
						key: 'graphPieResultList',
						value: data !== null && data !== undefined ? data.body.graphPieChartInfo : null
					});
					// 리스트 그래프 조회 상태업데이트
					commit(types.DEFAULT_ASSIGN, {
						key: 'graphMixedChartInfo',
						value: data !== null && data !== undefined ? data.body.graphMixedChartInfo : null
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	getGraphList_({ commit, state }) {
		const { searchParams } = state;

		return api
			.getGraphList({ searchParams })
			.then(data => {
				if (data.header.code === 0) {
					//console.log('조회된 값은:', data.body);

					// 바스택 조회 상태업데이트
					commit(types.DEFAULT_ASSIGN, {
						key: 'graphBarStackChartInfo',
						value: data !== null && data !== undefined ? data.body.graphBarStackChartInfo : null
					});

					// 파이 그래프 조회 상태업데이트
					commit(types.DEFAULT_ASSIGN, {
						key: 'graphPieResultList',
						value: data !== null && data !== undefined ? data.body.graphPieChartInfo : null
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	} /*,
	setVariableManagement_({ commit }, param) {
		return api
			.postVariableManagement(param)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'variableManagements',
						value: data !== null && data !== undefined ? data.body[0] : null
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
	*/,
	async excelTempDown_(store, params) {
		try {
			const response = await api.excelTempDown(params);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			return error?.header;
		}
		// try {
		// 	const response = await api
		// 		.excelTempDown(params)
		// 		.then(response => {
		// 			console.log('response', response);
		// 			const url = window.URL.createObjectURL(new Blob([response.data]));
		// 			const link = document.createElement('a');
		// 			link.href = url;
		// 			const filename = decodeURIComponent(response.headers.filename);
		// 			link.setAttribute('download', filename);
		// 			//console.log('filename', filename);
		// 			document.body.appendChild(link);
		// 			link.click();
		// 		})
		// 		.catch(error => {
		// 			throw error;
		// 		});
		// } catch (error) {
		// 	return error?.header;
		// }
	}
};
